import { IUserPreferences, USER_PREFERENCES } from "./types";

export const addUserPreferencesInSpace = (
  userId: string,
  userPreferences: IUserPreferences,
) => ({
  payload: { userId, userPreferences },
  type: USER_PREFERENCES,
});
